﻿import { BlobServiceClient } from "@azure/storage-blob";
import { HelperFunctions } from "helpers";
import pako from "pako";

export const BlobStorageService = {
    downloadFile(storageName, containerName, filename, token, downloadName) {
        return new Promise((resolve, reject) => {
            this.fetchFile(storageName, containerName, filename, token).then(async function (contents) {
                const compressedBuffer = await contents.arrayBuffer();
                const uint8 = new Uint8Array(compressedBuffer);
                const firstByte = 0x1f;
                const secondByte = 0x8b;
                const isGzip = uint8[0] === firstByte && uint8[1] === secondByte;

                let outputBlob;
                if (isGzip) {
                    const decompressedData = pako.ungzip(uint8);
                    outputBlob = new Blob([decompressedData]);
                } else {
                    outputBlob = contents;
                }
                HelperFunctions.downloadFile(outputBlob, downloadName);
                resolve();
            }, function (error) {
                reject(error);
            })
        });
    },
    fetchFile(storageName, containerName, filename, token) {
        return new Promise((resolve, reject) => {
            const blobServiceClient = new BlobServiceClient(`${storageName}?${token}`);

            const containerClient = blobServiceClient.getContainerClient(containerName);
            const blobClient = containerClient.getBlobClient(filename);

            blobClient.download().then(function (downloadBlockBlobResponse) {
                downloadBlockBlobResponse.blobBody.then(function (contents) {
                    resolve(contents);
                })
            }, function (error) {
                reject(error);
            });

        });
    }
}